import { Container, Flex, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { RedCardWithDownloadButton } from '@/components/ui/shared/cards/RedCardWithDownloadButton/RedCardWithDownloadButton';

export const DetailsSection = () => {
  const { t } = useTranslation();

  return (
    <Container textAlign="center" pb={20}>
      <Flex flexDirection="column" maxW="800px" margin="auto">
        <Flex
          textAlign={{ base: 'left', lg: 'center' }}
          flexDirection="column"
          alignItems="center"
          maxW="800px"
          margin="auto"
        >
          <Text fontFamily="heading" fontSize="3xl">
            {t('inPersonEventsPage.detailsHeading.0')}
            <Text as="span" lineHeight={1} fontSize="3xl" fontFamily="heading" fontWeight="bold" color="violet.500">
              {t('inPersonEventsPage.detailsHeading.1')}
            </Text>
          </Text>
          <Text mt={6}>{t('inPersonEventsPage.detailsDescription')}</Text>
        </Flex>
        <Heading color="violet.500" fontSize="3xl" mb={8} mt={16}>
          {t('inPersonEventsPage.ourInPersonService')}
        </Heading>

        <Flex textAlign="left" alignItems="flex-start" flexDirection="column">
          <Text mb={4} fontFamily="heading" fontSize="2xl">
            {t('inPersonEventsPage.inPersonServices.0.heading')}
          </Text>
          <Flex flexDirection="column" alignItems="flex-start">
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.0.bullets.0')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.0.bullets.1')}
              </Text>
            </Text>
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.0.bullets.2')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.0.bullets.3')}
              </Text>
            </Text>
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.0.bullets.4')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.0.bullets.5')}
              </Text>
            </Text>
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.0.bullets.6')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.0.bullets.7')}
              </Text>
            </Text>
          </Flex>
        </Flex>
        <Flex textAlign="left" alignItems="flex-start" mt={8} flexDirection="column">
          <Text mb={4} fontFamily="heading" fontSize="2xl">
            {t('inPersonEventsPage.inPersonServices.1.heading')}
          </Text>
          <Flex flexDirection="column" alignItems="flex-start">
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.1.bullets.0')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.1.bullets.1')}
              </Text>
            </Text>
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.1.bullets.2')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.1.bullets.3')}
              </Text>
            </Text>
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.1.bullets.4')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.1.bullets.5')}
              </Text>
            </Text>
          </Flex>
        </Flex>
        <Flex textAlign="left" alignItems="flex-start" mt={8} flexDirection="column">
          <Text mb={4} fontFamily="heading" fontSize="2xl">
            {t('inPersonEventsPage.inPersonServices.2.heading')}
          </Text>
          <Flex flexDirection="column" alignItems="flex-start">
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.2.bullets.0')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.2.bullets.1')}
              </Text>
            </Text>
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.2.bullets.2')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.2.bullets.3')}
              </Text>
            </Text>
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.2.bullets.4')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.2.bullets.5')}
              </Text>
            </Text>
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.2.bullets.6')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.2.bullets.7')}
              </Text>
            </Text>
          </Flex>
        </Flex>
        <Flex textAlign="left" alignItems="flex-start" mt={8} flexDirection="column">
          <Text mb={4} fontFamily="heading" fontSize="2xl">
            {t('inPersonEventsPage.inPersonServices.3.heading')}
          </Text>
          <Flex flexDirection="column" alignItems="flex-start">
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.3.bullets.0')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.3.bullets.1')}
              </Text>
            </Text>
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.3.bullets.2')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.3.bullets.3')}
              </Text>
            </Text>
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.3.bullets.4')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.3.bullets.5')}
              </Text>
            </Text>
          </Flex>
        </Flex>
        <Flex textAlign="left" alignItems="flex-start" mt={8} flexDirection="column">
          <Text mb={4} fontFamily="heading" fontSize="2xl">
            {t('inPersonEventsPage.inPersonServices.4.heading')}
          </Text>
          <Flex flexDirection="column" alignItems="flex-start">
            <Text fontWeight="semibold">
              {t('inPersonEventsPage.inPersonServices.4.bullets.0')}
              <Text as="span" fontWeight="normal">
                {t('inPersonEventsPage.inPersonServices.4.bullets.1')}
              </Text>
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <RedCardWithDownloadButton
        slug="in-person-events-guide"
        mt={16}
        maxW="1000px"
        mx="auto"
        smallHeading={t('inPersonEventsPage.redCardSubheading')}
        heading={t('inPersonEventsPage.redCardHeading')}
      />
    </Container>
  );
};
